import { cn } from '@/lib/utils';
import { Check } from 'lucide-react';
import { useTranslations } from 'next-intl';
import Image from 'next/image';
import H5 from '../ui/H5';

export default function OurGuarantee({
    titleClassName,
    isAboutSection = false,
}: {
    titleClassName?: string;
    isAboutSection?: boolean;
}) {
    const t = useTranslations();

    const checkMarks = [
        t('AllServices.ensuringRightQuality'),
        t('AllServices.onSchedule'),
        t('AllServices.marketAppropriatePrice'),
        t('AllServices.deliveredToFacility'),
    ];

    return (
        <>
            <h3
                className={cn(
                    'text-h5 xl:text-h3 leading-tight font-medium',
                    titleClassName,
                )}
            >
                {t('Metadata.Services.headings.ourGuarantee')}:
            </h3>
            <div className="mt-[30px] xl:mt-[60px] flex flex-col gap-7 relative">
                {checkMarks.map((title, index) => (
                    <div className="flex items-center gap-7 relative z-1" key={index}>
                        <Check strokeWidth={1.5} className="min-w-6 min-h-6" />
                        <H5 className="font-normal leading-tight">{title}</H5>
                    </div>
                ))}
                {!isAboutSection && (
                    <Image
                        className="object-contain absolute -bottom-40 right-0 z-negative max-lg:scale-75 max-sm:-right-20 max-lg:-bottom-20 max-lg:-right-36"
                        width={610}
                        height={260}
                        src="/img/train.webp"
                        alt="Train"
                    />
                )}
            </div>
        </>
    );
}
